"use client";

import { PageHero } from "@widgets/page-hero";

import cardsGrid from "@shared/ui/cards-grid/cards-grid.module.scss";
import { FilterPaginationContainerWithMultiBadges } from "@shared/ui/filter-pagination-container-with-multi-badges";
import { PointCard } from "@shared/ui/point-card";

import { getCurrentCafesRestaurantsPoint } from "../api";
import type {
  CafesRestaurantsBadgeType,
  CafesRestaurantsPageType,
  CafesRestaurantsPoints,
  CafesRestaurantsType,
} from "../model/types";

import s from "./cafes-restaurants-page.module.scss";

export type CafesRestaurantsPageProps = {
  filters: CafesRestaurantsType[];
  badges: CafesRestaurantsBadgeType[];
  content: CafesRestaurantsPoints;
  hero: CafesRestaurantsPageType;
};

export const CafesRestaurantsPage = (props: CafesRestaurantsPageProps) => {
  const { filters, badges, content, hero } = props;

  return (
    <main className={s.root}>
      {hero?.titleWithIcon && (
        <PageHero
          variant="primary"
          textColor="brown"
          title={hero?.titleWithIcon}
        />
      )}
      <FilterPaginationContainerWithMultiBadges
        initialContent={content}
        filters={filters}
        badges={badges.map((b) => ({ uid: b.uid, label: b.type }))}
        badgesFilterKey="badges"
        fetchFunction={getCurrentCafesRestaurantsPoint}
        renderCard={(card) => (
          <PointCard
            key={card.uid}
            href={`/cafes-restaurants/${card.uid}`}
            title={card.title}
            description={card.description}
            clampDescriptionOnMobile
            location={card.location}
            averageCheck={card.averageCheck}
            phone={card.phone}
            workTimeList={card.workTimeList}
            photos={card.photos}
            // filters={
            //   card?.cafes_restaurants_types &&
            //   card?.cafes_restaurants_types?.length > 0
            //     ? card?.cafes_restaurants_types.map((type) => {
            //         return {
            //           uid: type?.uid,
            //           label: type?.type,
            //         };
            //       })
            //     : []
            // }
            badges={(card.cafes_restaurants_badge_types || []).map((b) => ({
              uid: b.uid,
              label: b.type,
            }))}
            overlayIcon={{ name: "food", fillColor: "gold" }}
          />
        )}
        paginationThreshold={6}
        cardsClassName={cardsGrid.root}
        filterProps={{ dropdownFieldLabel: "Локация" }}
        mapTo="cafes-restaurants"
      />
    </main>
  );
};

CafesRestaurantsPage.displayName = "CafesRestaurantsPage";
